<template>
  <Layout>
    <div class="material-page-tab">
      <span class="material-page-label">素材分类</span>
      <router-link :to="{ name: 'material-img' }">图片素材</router-link>
      <router-link :to="{ name: 'material-bg-img' }">背景素材</router-link>
      <router-link :to="{ name: 'material-bg-color' }">背景颜色</router-link>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/views/layout/Layout'
export default {
  components: {
    Layout
  }
}
</script>
<style lang="scss" scoped>
.material-page-tab {
  position: sticky;
  display: flex;
  align-items: center;
  width: 100%;
  height: 65px;
  padding: 10px 40px 0;
  // background: rgba(255, 255, 255, 0.5);
  background: #ffffff;
  box-sizing: border-box;
  .material-page-label {
    display: inline-block;
    margin-right: 10px;
    font-size: 14px;
  }
  a {
    display: inline-block;
    height: 26px;
    padding: 3px 8px;
    margin-right: 20px;
    font-weight: 500;
    color: #535353;
    border-radius: 4px;
    box-sizing: border-box;
    &.router-link-active {
      color: #ffffff;
      background: #3366FF;
    }
  }
}
</style>